import { actionDuckUtils } from 'wanderu-ducks-utils';

import sliceNamespace from '../../types';
import { serializePredictionParams } from '../utils';

const namespace = 'FETCH_PLACE_FROM_TEXT';
const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(namespace, sliceNamespace, serializePredictionParams);

export {
    actions,
    namespace,
    reducer,
    selectors,
};
